/* Motivo cart drawer. Uses Shopify's Cart AJAX API + Section Rendering API. No dependencies. */
(function () {
  if (window.MvCart) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'motivo-cart-drawer';
  var BUBBLES = ['cart-icon-bubble', 'mobile-cart-icon-bubble'];
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var recsCache = {};

  function sectionIds() {
    return [SECTION].concat(BUBBLES.filter(function (id) { return document.getElementById(id); }));
  }

  function inner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function postJSON(url, body) {
    return nativeFetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  class MvCartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.onKey = this.onKey.bind(this);
    }

    get panel() { return this.querySelector('.mv-cd__panel'); }

    open() {
      if (this.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.classList.add('is-active');
      document.documentElement.classList.add('mv-cd-lock');
      void this.panel.offsetWidth; /* commit the closed position so the slide-in animates */
      this.classList.add('is-open');
      this.panel.focus({ preventScroll: true });
      document.addEventListener('keydown', this.onKey);
      this.loadRecs();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('mv-cd-lock');
      document.removeEventListener('keydown', this.onKey);
      setTimeout(() => { if (!this.classList.contains('is-open')) this.classList.remove('is-active'); }, 350);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    onKey(e) {
      if (e.key === 'Escape') this.close();
      if (e.key !== 'Tab') return;
      var f = this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onClick(e) {
      if (e.target.closest('[data-mv-cd-close]')) { e.preventDefault(); this.close(); return; }

      var q = e.target.closest('[data-mv-qty]');
      if (q) {
        var item = q.closest('[data-key]');
        this.change(item, parseInt(q.dataset.mvQty, 10));
        return;
      }

      var rm = e.target.closest('[data-mv-code-remove]');
      if (rm) {
        var code = rm.dataset.mvCodeRemove.toLowerCase();
        this.setCodes(this.codes().filter(function (c) { return c.toLowerCase() !== code; }));
      }
    }

    onSubmit(e) {
      var form = e.target.closest('[data-mv-code-form]');
      if (!form) return;
      e.preventDefault();
      var code = form.code.value.trim();
      if (!code) return;
      var codes = this.codes();
      if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { form.code.value = ''; return; }
      form.classList.add('is-loading');
      var self = this;
      this.setCodes(codes.concat(code)).then(function (cart) {
        if (!cart) return;
        var hit = (cart.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (!hit || !hit.applicable) {
          return self.setCodes(codes).then(function () {
            self.codeError(code.toUpperCase() + ' isn’t valid for the items in your cart.');
          });
        }
      });
    }

    codes() {
      return (this.dataset.codes || '').split(',').filter(Boolean);
    }

    codeError(msg) {
      var d = this.querySelector('[data-mv-code]');
      var p = this.querySelector('[data-mv-code-error]');
      if (d) d.open = true;
      if (p) { p.textContent = msg; p.hidden = false; }
    }

    setCodes(list) {
      return postJSON('cart/update.js', { discount: list.join(','), sections: sectionIds(), sections_url: location.pathname })
        .then((cart) => { this.render(cart.sections); return cart; })
        .catch(() => { this.codeError('Something went wrong. Please try again.'); });
    }

    change(item, qty) {
      if (!item || item.classList.contains('is-loading')) return;
      item.classList.add('is-loading');
      postJSON('cart/change.js', { id: item.dataset.key, quantity: Math.max(0, qty), sections: sectionIds(), sections_url: location.pathname })
        .then((cart) => { this.render(cart.sections); MvCart.notify(cart); })
        .catch((err) => {
          item.classList.remove('is-loading');
          var msg = item.querySelector('.mv-cd__err') || document.createElement('p');
          msg.className = 'mv-cd__err';
          msg.textContent = (err && (err.description || err.message)) || 'Couldn’t update quantity.';
          item.querySelector('.mv-cd__info').appendChild(msg);
        });
    }

    render(sections) {
      if (!sections) return;
      BUBBLES.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && sections[id]) {
          var html = inner(sections[id], '.shopify-section');
          if (html !== null) el.innerHTML = html;
        }
      });
      var html = sections[SECTION];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('mv-cart-drawer');
      if (!next) return;

      var body = this.querySelector('[data-mv-cd-body]');
      var scroll = body ? body.scrollTop : 0;
      var codeOpen = !!this.querySelector('[data-mv-code][open]');

      this.dataset.codes = next.dataset.codes || '';
      this.dataset.count = next.dataset.count || '0';
      this.dataset.firstProduct = next.dataset.firstProduct || '';
      this.panel.innerHTML = next.querySelector('.mv-cd__panel').innerHTML;

      var nb = this.querySelector('[data-mv-cd-body]');
      if (nb) nb.scrollTop = scroll;
      var d = this.querySelector('[data-mv-code]');
      if (d && codeOpen) d.open = true;
      this.loadRecs();
    }

    loadRecs() {
      var box = this.querySelector('[data-mv-recs]');
      if (!box || box.dataset.loaded) return;
      box.dataset.loaded = '1';
      var list = box.querySelector('[data-mv-recs-list]');
      var fallback = this.querySelector('template[data-mv-recs-fallback]');
      var pid = MvCart.lastProduct || this.dataset.firstProduct;
      var keys = Array.prototype.map.call(this.querySelectorAll('[data-key]'), function (el) { return el.dataset.key; }).join('|');
      var cacheKey = pid + ':' + keys;

      function show(html) {
        if (!html || !html.trim()) html = fallback ? fallback.innerHTML : '';
        list.innerHTML = html;
        box.classList.toggle('is-ready', !!list.children.length);
      }

      if (!pid) return show('');
      if (recsCache[cacheKey] !== undefined) return show(recsCache[cacheKey]);
      nativeFetch(ROOT + 'recommendations/products?product_id=' + pid + '&limit=8&intent=related&section_id=motivo-cart-recs')
        .then(function (r) { return r.text(); })
        .then(function (t) { recsCache[cacheKey] = inner(t, '[data-mv-recs-result]') || ''; show(recsCache[cacheKey]); })
        .catch(function () { show(''); });
    }
  }

  if (!customElements.get('mv-cart-drawer')) customElements.define('mv-cart-drawer', MvCartDrawer);

  var MvCart = (window.MvCart = {
    lastProduct: null,
    drawer: function () { return document.querySelector('mv-cart-drawer'); },
    open: function () { var d = this.drawer(); if (d) d.open(); },
    refresh: function (openAfter) {
      var d = this.drawer();
      if (!d) return Promise.resolve();
      return nativeFetch(ROOT + '?sections=' + sectionIds().join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) { d.render(sections); if (openAfter) d.open(); });
    },
    notify: function (cart) {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mv-cart', cartData: cart }); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('mv:cart:updated', { detail: cart }));
    }
  });

  /* ---- Add to cart: take over every /cart/add form on the page ---- */
  function formError(form, msg) {
    var pf = form.closest('product-form') || form.parentElement;
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (wrap) {
      wrap.hidden = false;
      var m = wrap.querySelector('.product-form__error-message');
      if (m) m.textContent = msg;
      return;
    }
    var p = form.querySelector('.mv-form-error') || document.createElement('p');
    p.className = 'mv-form-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    form.appendChild(p);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action) || !MvCart.drawer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = e.submitter || form.querySelector('[type="submit"]') ||
      (form.id && document.querySelector('[type="submit"][form="' + form.id + '"]'));
    if (btn && (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading'))) return;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var old = form.querySelector('.mv-form-error');
    if (old) old.remove();
    var pf = form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (wrap) wrap.hidden = true;

    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', location.pathname);

    nativeFetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { formError(form, res.description || res.message || 'Couldn’t add to cart.'); return; }
        MvCart.lastProduct = res.product_id || (res.items && res.items[0] && res.items[0].product_id) || MvCart.lastProduct;
        var d = MvCart.drawer();
        d.render(res.sections);
        d.open();
        MvCart.notify(res);
      })
      .catch(function () { formError(form, 'Couldn’t add to cart. Please try again.'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);

  /* ---- Cart links open the drawer ---- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.closest('mv-cart-drawer')) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname) || /\/cart\/?$/.test(location.pathname)) return;
    if (!MvCart.drawer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    MvCart.open();
  }, true);

  /* ---- Cart changes made by other scripts (apps, theme) keep the drawer in sync ---- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) {
      p.then(function (r) { if (r.ok) MvCart.refresh(/\/cart\/add/.test(url)); }).catch(function () {});
    }
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) MvCart.refresh(/\/cart\/add/.test(String(url)));
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  /* Open on load when a link asks for it, e.g. /?cart=open */
  if (/[?&]cart=open/.test(location.search)) {
    document.addEventListener('DOMContentLoaded', function () { MvCart.open(); });
  }
})();
